import { bool, func } from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import sty from '../styles/Tabs.module.css';

/**
 * @component TabButtons
 * @param { Object } props
 * @param { function } props.onSave
 * @param { function } props.onReset
 * @param { function } props.onCreate
 * @param { boolean } props.isOpenSubtab
 * @returns { JSX.Element }
 */
function TabButtons(props) {
	return (
		<section className={sty.tab_btn_section}>
			<Tooltip arrow title="Create a new tab or folder" placement="right-start">
				<IconButton component="div" onClick={props.onCreate}>
					<AddCircleOutlineOutlinedIcon />
				</IconButton>
			</Tooltip>
			<div className={sty.tab_btn_btns}>
				<Button
					className={sty.tab_btn_btn}
					variant="outlined"
					size="small"
					color="sds"
					disabled={props.isOpenSubtab}
					onClick={props.onSave}
				>
					SAVE
				</Button>
				<Button
					className={sty.tab_btn_btn}
					variant="outlined"
					size="small"
					color="sds"
					onClick={props.onReset}
				>
					RESET
				</Button>
			</div>
		</section>
	);
}

TabButtons.propTypes = {
	onSave: func,
	onReset: func,
	onCreate: func,
	isOpenSubtab: bool,
};

export default TabButtons;
